export default "__VITE_ASSET__OE44Ketu__"